import dynaForms from '@elab/core/utils/dynaForms';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';
import * as addressRelations from '@elab/core/utils/addressRelations';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as addressRelationsInitialState } from '@elab/core/utils/addressRelations/reducers';

import getTypes from './types';

export const initialState = state => ({
    ...dynaInitialState(state),
    ...addressRelationsInitialState(state),
});
const createReducer = storeName => {
    const types = getTypes(storeName);
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const addressSuggestionsReduce = addressRelations.createReducer(storeName);

    return (state = initialState(), action) => {
        state = dynaFormReduce(state, action);
        state = addressSuggestionsReduce(state, action);
        switch (action.type) {
            case types.SET_EDITING:
                return {
                    ...state,
                    isEditing: true,
                    editingID: action.payload.id,
                };
            case types.RESET:
                return {
                    ...state,
                    isEditing: false,
                    editingID: null,
                    addressType: null,
                };

            case types.SET_ADDRESS_TYPE:
                return reduceAction(state, 'addressType', action.payload.addressType);

            case types.SET_RADIO_VIEW:
                return reduceAction(state, 'radioView', action.payload.radioView);

            case types.SET_SUBMIT_EDIT_URL:
                return reduceAction(state, 'submitEditUrl', action.payload.submitEditUrl);

            case types.SET_SUBMIT_ADD_URL:
                return reduceAction(state, 'submitAddUrl', action.payload.submitAddUrl);

            case types.SET_SUBMIT_EDIT_METHOD:
                return reduceAction(state, 'submitEditMethod', action.payload.submitEditMethod);

            case types.SET_SELECT_FOR_PAYMENT_AFTER_EDITING:
                return reduceAction(
                    state,
                    'selectForPaymentAfterEditing',
                    action.payload.selectForPaymentAfterEditing,
                );

            default:
                return state;
        }
    };
};

export default createReducer;
